/* ==========================================================================
   Printeo — fiche produit, bloc papier et page papier (lot C). Vanilla, chargé en defer.
   <pt-galerie>        : diapositives (défilement au doigt, scroll-snap), flèches, vignettes,
                         points (téléphone) ; l'image du coloris choisi s'affiche.
   <pt-produit>        : coloris sans rechargement (prix, disponibilité, image, adresse
                         ?variant=, identifiant envoyé au panier), case papier, ajout AJAX.
   <pt-barre-produit>  : onglets collants (ordinateur), barre d'achat basse (téléphone).
   <pt-duo-papier>     : « imprimante + papier, Ajouter les deux · total ».
   <pt-achat-simple>   : ajout AJAX d'un formulaire à une variante (page papier).
   Quantité            : boutons − / + (délégation).
   Panier : un seul appel /cart/add.js avec « items » et les sections du tiroir
   (PT.panier.sections(), lot A) ; émet « pt:panier:ajout » sur document (detail : { items,
   sections, source }) que le tiroir du lot A écoute ; PT.cartType = 'page' : page
   panier. Sans JavaScript, chaque formulaire s'envoie normalement.
   Événement « pt:variante » (detail : { produit, variante }) à chaque changement de coloris.
   Aucun texte ni montant écrit ici : libellés et prix formatés viennent du JSON rendu par
   les sections (money) ou des attributs data-*.
   ========================================================================== */
(() => {
  'use strict';

  if (window.PTProduitCharge) return;
  window.PTProduitCharge = true;

  const PT = (window.PT = window.PT || {});
  const mouvementReduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mqOrdinateur = window.matchMedia('(min-width: 990px)');

  const lireJSON = (racine, selecteur) => {
    const script = racine.querySelector(selecteur);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (erreur) {
      return null;
    }
  };

  /* --- Panier : envoi commun ------------------------------------------- */

  function viderStatut(statut) {
    if (statut) statut.replaceChildren();
  }

  function messageErreur(statut, texte) {
    if (!statut) return;
    const p = document.createElement('p');
    p.className = 'pt-fiche__message pt-fiche__message--erreur';
    p.textContent = texte || '';
    statut.replaceChildren(p);
  }

  function messageSucces(statut, modele) {
    if (!statut || !modele) return;
    statut.replaceChildren(modele.content.cloneNode(true));
  }

  /**
   * Ajoute des lignes au panier en un seul appel. Renvoie true si l'ajout a réussi.
   * ctx : { boutons: [], statut, modele, textes: { erreur, erreurQuantite }, source }
   */
  async function envoyer(items, ctx) {
    const routes = PT.routes || {};
    const boutons = (ctx.boutons || []).filter(Boolean);
    boutons.forEach((b) => b.setAttribute('aria-busy', 'true'));
    viderStatut(ctx.statut);
    // Sections du tiroir (lot A) rendues dans la même réponse : le tiroir les applique sans
    // nouvel appel. Sans elles, il relit lui-même ses sections.
    const corps = { items };
    const panier = PT.panier;
    if (panier && typeof panier.sections === 'function') {
      const ids = panier.sections().filter(Boolean);
      if (ids.length) corps.sections = ids.join(',');
    }
    try {
      const reponse = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(corps)
      });
      const donnees = await reponse.json().catch(() => ({}));
      if (!reponse.ok) {
        const textes = ctx.textes || {};
        messageErreur(ctx.statut, reponse.status === 422 ? textes.erreurQuantite || textes.erreur : textes.erreur);
        return false;
      }
      if (PT.cartType === 'page') {
        window.location.href = routes.cart || '/cart';
        return true;
      }
      document.dispatchEvent(new CustomEvent('pt:panier:ajout', {
        detail: { items: donnees.items || [donnees], sections: donnees.sections || null, source: ctx.source || 'fiche' }
      }));
      messageSucces(ctx.statut, ctx.modele);
      return true;
    } catch (erreur) {
      messageErreur(ctx.statut, (ctx.textes || {}).erreur);
      return false;
    } finally {
      boutons.forEach((b) => b.removeAttribute('aria-busy'));
    }
  }

  const ajaxPossible = () => Boolean(window.fetch && window.JSON);

  /* --- Quantité ----------------------------------------------------------- */

  document.addEventListener('click', (evenement) => {
    const bouton = evenement.target.closest('[data-pt-quantite-pas]');
    if (!bouton) return;
    const zone = bouton.closest('.pt-quantite');
    const champ = zone ? zone.querySelector('[data-pt-quantite]') : null;
    if (!champ) return;
    const min = Number(champ.min) || 1;
    const max = Number(champ.max) || 99;
    const actuelle = parseInt(champ.value, 10) || min;
    champ.value = String(Math.min(max, Math.max(min, actuelle + Number(bouton.dataset.ptQuantitePas))));
    champ.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const lireQuantite = (champ) => {
    if (!champ) return 1;
    const min = Number(champ.min) || 1;
    const max = Number(champ.max) || 99;
    const valeur = Math.min(max, Math.max(min, parseInt(champ.value, 10) || min));
    champ.value = String(valeur);
    return valeur;
  };

  /* --- Galerie -------------------------------------------------------------- */

  class PtGalerie extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.piste = this.querySelector('[data-pt-piste]');
      if (!this.piste) return;
      this.pret = true;
      this.diapos = Array.from(this.piste.querySelectorAll('[data-media-id]'));
      this.vignettes = Array.from(this.querySelectorAll('[data-pt-vignette]'));
      this.listeVignettes = this.querySelector('[data-pt-vignettes]');
      this.points = Array.from(this.querySelectorAll('[data-pt-point]'));
      this.statut = this.querySelector('[data-pt-galerie-statut]');
      this.precedent = this.querySelector('[data-pt-precedent]');
      this.suivant = this.querySelector('[data-pt-suivant]');
      this.index = 0;

      if (this.precedent) this.precedent.addEventListener('click', () => this.aller(this.index - 1, true, true));
      if (this.suivant) this.suivant.addEventListener('click', () => this.aller(this.index + 1, true, true));
      this.vignettes.forEach((bouton) => {
        bouton.addEventListener('click', () => this.aller(Number(bouton.dataset.ptVignette), true, true));
      });

      if ('IntersectionObserver' in window) {
        this.observateur = new IntersectionObserver((entrees) => {
          entrees.forEach((entree) => {
            if (entree.isIntersecting) this.marquer(this.diapos.indexOf(entree.target), false);
          });
        }, { root: this.piste, threshold: 0.6 });
        this.diapos.forEach((diapo) => this.observateur.observe(diapo));
      } else {
        this.piste.addEventListener('scroll', () => {
          const largeur = this.piste.clientWidth || 1;
          this.marquer(Math.round(this.piste.scrollLeft / largeur), false);
        }, { passive: true });
      }
      this.marquer(0, false);
    }

    aller(index, anime = true, annoncer = false) {
      if (!this.diapos.length) return;
      const cible = Math.max(0, Math.min(this.diapos.length - 1, index));
      const diapo = this.diapos[cible];
      this.piste.scrollTo({ left: diapo.offsetLeft, behavior: anime && !mouvementReduit() ? 'smooth' : 'auto' });
      this.marquer(cible, annoncer);
    }

    allerMedia(idMedia, anime = true) {
      if (!idMedia) return;
      const index = this.diapos.findIndex((diapo) => diapo.dataset.mediaId === String(idMedia));
      if (index > -1) this.aller(index, anime, false);
    }

    marquer(index, annoncer) {
      if (index < 0 || index >= this.diapos.length) return;
      const change = index !== this.index;
      this.index = index;
      const total = this.diapos.length;
      this.vignettes.forEach((bouton, i) => {
        if (i === index) bouton.setAttribute('aria-current', 'true');
        else bouton.removeAttribute('aria-current');
      });
      this.points.forEach((point, i) => point.classList.toggle('pt-galerie__point--actif', i === index));
      if (this.precedent) this.precedent.disabled = index === 0;
      if (this.suivant) this.suivant.disabled = index === total - 1;
      if (this.statut && annoncer && change) {
        this.statut.textContent = (this.statut.dataset.modele || '').split('[n]').join(String(index + 1));
      }
      this.montrerVignette(index);
    }

    // Garde la vignette active visible dans sa liste, sans faire défiler la page.
    montrerVignette(index) {
      const liste = this.listeVignettes;
      const bouton = this.vignettes[index];
      if (!liste || !bouton) return;
      const verticale = liste.scrollHeight > liste.clientHeight + 2;
      const horizontale = liste.scrollWidth > liste.clientWidth + 2;
      const comportement = mouvementReduit() ? 'auto' : 'smooth';
      const element = bouton.parentElement || bouton;
      if (verticale) {
        const haut = element.offsetTop;
        const bas = haut + element.offsetHeight;
        if (haut < liste.scrollTop) liste.scrollTo({ top: haut, behavior: comportement });
        else if (bas > liste.scrollTop + liste.clientHeight) liste.scrollTo({ top: bas - liste.clientHeight, behavior: comportement });
      } else if (horizontale) {
        const gauche = element.offsetLeft;
        const droite = gauche + element.offsetWidth;
        if (gauche < liste.scrollLeft) liste.scrollTo({ left: gauche, behavior: comportement });
        else if (droite > liste.scrollLeft + liste.clientWidth) liste.scrollTo({ left: droite - liste.clientWidth, behavior: comportement });
      }
    }
  }

  /* --- Fiche : coloris et ajout au panier ----------------------------------- */

  class PtProduit extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.donnees = lireJSON(this, '[data-pt-produit-donnees]');
      if (!this.donnees) return;
      this.pret = true;
      this.variantes = this.donnees.variantes || [];
      this.textes = this.donnees.textes || {};
      this.formulaire = document.getElementById(this.donnees.formulaire) || this.querySelector('form');
      if (!this.formulaire) return;
      this.champId = this.formulaire.querySelector('[data-pt-id]');
      this.radios = Array.from(this.formulaire.querySelectorAll('[data-pt-variante]'));
      this.nomColoris = this.querySelector('[data-pt-coloris-nom]');
      this.zonePrix = this.querySelector('[data-pt-prix-zone]');
      this.bouton = this.formulaire.querySelector('[data-pt-ajout]');
      this.texteBouton = this.formulaire.querySelector('[data-pt-ajout-texte]');
      this.quantite = this.formulaire.querySelector('[data-pt-quantite]');
      this.casePapier = this.formulaire.querySelector('[data-pt-papier]');
      this.statut = this.formulaire.querySelector('[data-pt-statut]');
      this.modele = this.formulaire.querySelector('[data-pt-modele-succes]');
      this.galerie = this.querySelector('pt-galerie');

      // Avec JavaScript, l'identifiant envoyé au panier est le champ caché : les pastilles
      // portent un autre nom (sans JavaScript, ce sont elles qui portent name="id").
      if (this.radios.length && this.champId) {
        const nom = `pt-coloris-${this.dataset.section || this.donnees.produit}`;
        this.radios.forEach((radio) => {
          radio.name = nom;
          radio.addEventListener('change', () => { if (radio.checked) this.choisir(radio.value, true); });
        });
        this.champId.name = 'id';
        const coche = this.radios.find((radio) => radio.checked);
        if (coche) this.champId.value = coche.value;
      }

      this.variante = this.trouver(this.champId ? this.champId.value : null) || this.variantes[0] || null;
      this.formulaire.addEventListener('submit', (evenement) => this.ajouter(evenement));
      if (this.casePapier) this.casePapier.addEventListener('change', () => viderStatut(this.statut));
      if (this.variante) this.choisir(this.variante.id, false, true);
    }

    trouver(id) {
      return this.variantes.find((v) => String(v.id) === String(id)) || null;
    }

    choisir(id, majAdresse, initial = false) {
      const variante = this.trouver(id);
      if (!variante) return;
      this.variante = variante;
      if (this.champId) this.champId.value = String(variante.id);
      this.radios.forEach((radio) => { radio.checked = radio.value === String(variante.id); });
      if (this.nomColoris) this.nomColoris.textContent = variante.libelle;
      if (!initial && this.zonePrix && variante.prixHtml) this.zonePrix.innerHTML = variante.prixHtml;
      if (this.bouton) this.bouton.disabled = !variante.disponible;
      if (this.texteBouton) this.texteBouton.textContent = variante.disponible ? this.textes.ajouter : this.textes.indisponible;
      if (!initial && this.galerie && typeof this.galerie.allerMedia === 'function' && variante.media) this.galerie.allerMedia(variante.media);
      if (majAdresse && variante.url) {
        const adresse = new URL(variante.url, window.location.origin);
        const actuelle = new URL(window.location.href);
        actuelle.searchParams.set('variant', adresse.searchParams.get('variant') || String(variante.id));
        window.history.replaceState(window.history.state, '', actuelle.toString());
      }
      if (!initial) viderStatut(this.statut);
      document.dispatchEvent(new CustomEvent('pt:variante', { detail: { produit: String(this.donnees.produit), variante } }));
    }

    ajouter(evenement) {
      if (!ajaxPossible()) return; // repli : envoi natif du formulaire
      evenement.preventDefault();
      if (!this.variante || !this.variante.disponible || this.envoi) return;
      const items = [{ id: Number(this.variante.id), quantity: lireQuantite(this.quantite) }];
      if (this.casePapier && this.casePapier.checked && !this.casePapier.closest('[hidden]')) {
        items.push({ id: Number(this.casePapier.value), quantity: 1 });
      }
      this.envoi = true;
      const boutons = [this.bouton];
      if (evenement.submitter && evenement.submitter !== this.bouton) boutons.push(evenement.submitter);
      envoyer(items, { boutons, statut: this.statut, modele: this.modele, textes: this.textes, source: 'fiche' })
        .finally(() => { this.envoi = false; });
    }
  }

  /* --- Barre de la fiche ---------------------------------------------------- */

  class PtBarreProduit extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.pret = true;
      this.racine = document.documentElement;
      this.prix = Array.from(this.querySelectorAll('[data-pt-barre-prix]'));
      this.boutons = Array.from(this.querySelectorAll('[data-pt-barre-bouton]'));
      this.boutonsPrix = Array.from(this.querySelectorAll('[data-pt-barre-bouton-prix]'));
      this.mobile = this.querySelector('[data-pt-barre-mobile]');
      this.bande = this.querySelector('.pt-barre__bande');
      this.etat = { boutonPasse: false, piedVisible: false };

      document.addEventListener('pt:variante', (evenement) => {
        if (!evenement.detail || evenement.detail.produit !== this.dataset.produit) return;
        this.maj(evenement.detail.variante);
      });
      this.produit = document.querySelector(`pt-produit[data-produit="${this.dataset.produit}"]`);
      if (this.produit && this.produit.variante) this.maj(this.produit.variante);

      this.retirerOngletsOrphelins();
      this.mesurer();
      this.observerOnglets();
      this.observerBarreMobile();
      mqOrdinateur.addEventListener('change', () => { this.mesurer(); this.afficherMobile(); });
    }

    maj(variante) {
      if (!variante) return;
      this.prix.forEach((el) => { el.textContent = variante.prix; });
      const indisponible = this.produit && this.produit.textes ? this.produit.textes.indisponible : '';
      this.boutonsPrix.forEach((el) => { el.textContent = variante.disponible ? variante.boutonPrix : indisponible || el.textContent; });
      this.boutons.forEach((bouton) => { bouton.disabled = !variante.disponible; });
    }

    retirerOngletsOrphelins() {
      this.onglets = Array.from(this.querySelectorAll('[data-pt-onglet]')).filter((lien) => {
        const cible = document.getElementById(decodeURIComponent(lien.hash.slice(1)));
        if (!cible) {
          const element = lien.closest('li') || lien;
          element.hidden = true;
          return false;
        }
        lien.ptCible = cible;
        return true;
      });
    }

    /* En-tête collant éventuel (lot A) : la bande se colle juste dessous ; les ancres tiennent
       compte de l'en-tête et de la bande. */
    mesurer() {
      const poser = () => {
        let entete = 0;
        document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group > *').forEach((element) => {
          const style = getComputedStyle(element);
          if (style.position === 'sticky' || style.position === 'fixed') {
            const haut = parseFloat(style.top) || 0;
            entete = Math.max(entete, Math.round(haut + element.offsetHeight));
          }
        });
        const bande = mqOrdinateur.matches && this.bande ? this.bande.offsetHeight : 0;
        this.racine.style.setProperty('--pt-entete-collant', `${entete}px`);
        this.racine.style.setProperty('--pt-ancre-decalage', `${entete + bande + 16}px`);
      };
      poser();
      if (!this.mesureObservee && 'ResizeObserver' in window) {
        this.mesureObservee = true;
        const observateur = new ResizeObserver(poser);
        observateur.observe(document.body);
        if (this.bande) observateur.observe(this.bande);
      }
    }

    observerOnglets() {
      if (!this.onglets.length || !('IntersectionObserver' in window)) return;
      const activer = (cible) => {
        this.onglets.forEach((lien) => {
          if (lien.ptCible === cible) lien.setAttribute('aria-current', 'true');
          else lien.removeAttribute('aria-current');
        });
      };
      const observateur = new IntersectionObserver((entrees) => {
        entrees.forEach((entree) => { if (entree.isIntersecting) activer(entree.target); });
      }, { rootMargin: '-35% 0px -60% 0px' });
      this.onglets.forEach((lien) => observateur.observe(lien.ptCible));
    }

    /* Barre d'achat basse (< 990 px) : visible quand le bouton principal est passé au-dessus de
       l'écran, masquée quand le pied de page approche (elle ne le recouvre jamais). */
    observerBarreMobile() {
      if (!this.mobile || !('IntersectionObserver' in window)) return;
      const cible = document.getElementById(this.dataset.cible);
      if (cible) {
        new IntersectionObserver(([entree]) => {
          this.etat.boutonPasse = !entree.isIntersecting && entree.boundingClientRect.top < 0;
          this.afficherMobile();
        }).observe(cible);
      }
      const pied = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      if (pied) {
        const marge = () => Math.max(80, this.mobile.offsetHeight || 0);
        new IntersectionObserver(([entree]) => {
          this.etat.piedVisible = entree.isIntersecting;
          this.afficherMobile();
        }, { rootMargin: `0px 0px ${marge()}px 0px` }).observe(pied);
      }
      const poserHauteur = () => this.racine.style.setProperty('--pt-barre-achat-h', `${this.mobile.offsetHeight}px`);
      poserHauteur();
      if ('ResizeObserver' in window) new ResizeObserver(poserHauteur).observe(this.mobile);
    }

    afficherMobile() {
      if (!this.mobile) return;
      const visible = !mqOrdinateur.matches && this.etat.boutonPasse && !this.etat.piedVisible;
      this.mobile.dataset.visible = String(visible);
      this.racine.classList.toggle('pt-barre-achat-visible', visible);
    }
  }

  /* --- Imprimante + papier ---------------------------------------------------- */

  class PtDuoPapier extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.donnees = lireJSON(this, '[data-pt-duo-donnees]');
      if (!this.donnees) return;
      this.pret = true;
      this.formulaire = this.querySelector('form');
      this.caseImprimante = this.querySelector('[data-pt-duo-imprimante]');
      this.casePapier = this.querySelector('[data-pt-duo-papier]');
      this.bouton = this.querySelector('[data-pt-duo-bouton]');
      this.texteBouton = this.querySelector('[data-pt-duo-bouton-texte]');
      this.libelle = this.querySelector('[data-pt-duo-libelle]');
      this.prix = this.querySelector('[data-pt-duo-prix]');
      this.vignette = this.querySelector('[data-pt-duo-vignette]');
      this.nomColoris = this.querySelector('[data-pt-duo-coloris-nom]');
      this.statut = this.querySelector('[data-pt-statut]');
      this.modele = this.querySelector('[data-pt-modele-succes]');
      this.imprimantes = this.donnees.imprimantes || [];
      this.imprimante = this.imprimantes.find((v) => String(v.id) === String(this.caseImprimante && this.caseImprimante.value)) || null;

      [this.caseImprimante, this.casePapier].forEach((c) => {
        if (c) c.addEventListener('change', () => { viderStatut(this.statut); this.majBouton(); });
      });
      this.querySelectorAll('[data-pt-duo-choix]').forEach((radio) => {
        radio.addEventListener('change', () => { if (radio.checked) this.choisir(radio.value); });
      });
      if (this.hasAttribute('data-suivre-fiche')) {
        document.addEventListener('pt:variante', (evenement) => {
          if (!evenement.detail || evenement.detail.produit !== this.dataset.produit || !evenement.detail.variante) return;
          this.choisir(evenement.detail.variante.id);
        });
        const produit = document.querySelector(`pt-produit[data-produit="${this.dataset.produit}"]`);
        if (produit && produit.variante) this.choisir(produit.variante.id);
      }
      if (this.formulaire) this.formulaire.addEventListener('submit', (evenement) => this.ajouter(evenement));
      this.majBouton();
    }

    choisir(id) {
      const variante = this.imprimantes.find((v) => String(v.id) === String(id));
      if (!variante || !this.caseImprimante) return;
      const etaitInactive = this.caseImprimante.disabled;
      this.imprimante = variante;
      this.caseImprimante.value = String(variante.id);
      this.caseImprimante.disabled = !variante.disponible;
      if (!variante.disponible) this.caseImprimante.checked = false;
      else if (etaitInactive) this.caseImprimante.checked = true;
      if (this.libelle) this.libelle.textContent = variante.libelle;
      if (this.nomColoris) this.nomColoris.textContent = variante.libelle;
      if (this.prix) this.prix.textContent = variante.prix;
      if (this.vignette) {
        let image = this.vignette.querySelector('img');
        if (variante.image) {
          if (!image) {
            image = document.createElement('img');
            image.width = 64;
            image.height = 64;
            image.alt = '';
            image.decoding = 'async';
            this.vignette.replaceChildren(image);
          }
          image.src = variante.image;
        }
      }
      this.querySelectorAll('[data-pt-duo-choix]').forEach((radio) => { radio.checked = radio.value === String(variante.id); });
      this.majBouton();
    }

    majBouton() {
      if (!this.bouton) return;
      const imprimante = this.caseImprimante && this.caseImprimante.checked && !this.caseImprimante.disabled && this.imprimante;
      const papier = this.casePapier && this.casePapier.checked;
      let texte = this.donnees.textes.aucun;
      if (imprimante && papier) texte = this.imprimante.boutonDeux;
      else if (imprimante) texte = this.imprimante.boutonSeul;
      else if (papier) texte = this.donnees.papier.boutonSeul;
      if (this.texteBouton) this.texteBouton.textContent = texte;
      this.bouton.disabled = !(imprimante || papier);
    }

    ajouter(evenement) {
      if (!ajaxPossible()) return;
      evenement.preventDefault();
      if (this.envoi || this.bouton.disabled) return;
      const items = [];
      if (this.caseImprimante && this.caseImprimante.checked && !this.caseImprimante.disabled) items.push({ id: Number(this.caseImprimante.value), quantity: 1 });
      if (this.casePapier && this.casePapier.checked) items.push({ id: Number(this.casePapier.value), quantity: 1 });
      if (!items.length) return;
      this.envoi = true;
      envoyer(items, { boutons: [this.bouton], statut: this.statut, modele: this.modele, textes: this.donnees.textes, source: 'papier' })
        .finally(() => { this.envoi = false; });
    }
  }

  /* --- Formulaire à une variante (page papier) ----------------------------- */

  class PtAchatSimple extends HTMLElement {
    connectedCallback() {
      if (this.pret) return;
      this.formulaire = this.querySelector('form');
      if (!this.formulaire) return;
      this.pret = true;
      this.textes = lireJSON(this, '[data-pt-achat-textes]') || {};
      this.formulaire.addEventListener('submit', (evenement) => {
        if (!ajaxPossible()) return;
        evenement.preventDefault();
        const champ = this.formulaire.querySelector('[name="id"]');
        const bouton = this.formulaire.querySelector('[data-pt-ajout]');
        if (!champ || this.envoi || (bouton && bouton.disabled)) return;
        this.envoi = true;
        envoyer([{ id: Number(champ.value), quantity: lireQuantite(this.formulaire.querySelector('[data-pt-quantite]')) }], {
          boutons: [bouton],
          statut: this.formulaire.querySelector('[data-pt-statut]'),
          modele: this.formulaire.querySelector('[data-pt-modele-succes]'),
          textes: this.textes,
          source: 'page-papier'
        }).finally(() => { this.envoi = false; });
      });
    }
  }

  const definir = (nom, classe) => { if (!customElements.get(nom)) customElements.define(nom, classe); };
  definir('pt-galerie', PtGalerie);
  definir('pt-produit', PtProduit);
  definir('pt-barre-produit', PtBarreProduit);
  definir('pt-duo-papier', PtDuoPapier);
  definir('pt-achat-simple', PtAchatSimple);
})();
